<div class="content-container main">
  <router-outlet></router-outlet>
</div>
<app-loading *ngIf="loading"></app-loading>
